export const TEMPLATE_DEFAULT = 'Default';
export const TEMPLATE_PAGE_LOOK = 'PageLook';
export const TEMPLATE_LARGE_SIZE = 'GrandeTaille';
export const TEMPLATE_BIG_PRODUCTS = 'Template2';
